import React from 'react'
import { Outlet, useParams, useSearchParams } from 'react-router-dom'

import { EditTrainingQueryDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { EditModeLayout } from 'modules/trainings/components/EditModeLayout'
import { ConfigurationComponent } from 'modules/trainings/components/Revamp/TrainingEditMode/configurationComponent'
import {
  AvailableSections,
  options,
} from 'modules/trainings/components/Revamp/TrainingEditMode/editionOptions'
import { useEditTrainingContext } from 'modules/trainings/hooks/EditTraining/useEditTrainingContext'

const EditTraining = () => {
  const { id } = useParams()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading } = useQuery(EditTrainingQueryDocument, {
    variables: {
      categories: ['training'],
      id: String(id),
      companyId,
    },
    fetchPolicy: 'network-only',
  })

  const [searchParams] = useSearchParams()
  const selectedSection = searchParams.get('section') ?? AvailableSections.basic

  const { saved, isDirty, setSaved, isDisabled, courseValidityToggle, setCourseValidityToggle } =
    useEditTrainingContext()

  const training = data?.trainings.trainingsConnection.nodes.at(0)

  const relatorioEnabled = !!data?.trainings.settingsConnection.nodes?.find(
    (n) => n.relatorioEnabled
  )

  if (loading || !data || !training) return <Loading expand />

  return (
    <ResponsivePage.NestedBody>
      <Outlet
        context={{
          saved,
          isDirty,
          setSaved,
          isDisabled,
          courseValidityToggle,
          setCourseValidityToggle,
        }}
      />
      <EditModeLayout
        options={options(relatorioEnabled)}
        isDirty={isDirty}
        isDisabled={isDisabled}
        setSaved={setSaved}
        defaultSection={AvailableSections.basic}
      >
        <ConfigurationComponent
          competencies={data.competencies.competencies}
          categories={data.trainings.categories}
          processes={data.processes.processesConnection.nodes}
          saved={saved}
          selected={selectedSection}
          training={training}
        />
      </EditModeLayout>
    </ResponsivePage.NestedBody>
  )
}

export default EditTraining
